export default __webpack_public_path__ + "static/media/postman.4e7a173b.svg";